export class ProspectTree {
  hsFreshman: boolean;
  hsSophomore: boolean;
  hsJunior: boolean;
  hsSenior: boolean;
  hsStudent: boolean;
  hsGraduate: boolean;
  collegeStudent: boolean;
  collegeGraduate: boolean;
  adultLearner: boolean;
  middleSchooler: boolean;

  constructor (hsFreshman?: boolean,
    hsSophomore?: boolean, 
    hsJunior?: boolean, 
    hsSenior?: boolean, 
    hsStudent?: boolean, 
    hsGraduate?: boolean, 
    collegeStudent?: boolean,
    collegeGraduate?: boolean,
    adultLearner?: boolean,
    middleSchooler?: boolean) {
      this.hsFreshman = hsFreshman || false;
      this.hsSophomore = hsSophomore || false;
      this.hsJunior = hsJunior || false;
      this.hsSenior = hsSenior || false;
      this.hsStudent = hsStudent || false;
      this.hsGraduate = hsGraduate || false;
      this.collegeStudent = collegeStudent || false;
      this.collegeGraduate = collegeGraduate || false;
      this.adultLearner = adultLearner || false;
      this.middleSchooler = middleSchooler || false;
  }
}

export class VisitorTypeReducerState {
  prospectiveStudents: ProspectTree;
  parentsOfProspects: ProspectTree;
  currentStudent: boolean;
  alumni: boolean;
  faculty: boolean;
  guidanceCounselor: boolean;
  veteran: boolean;

  constructor (prospectiveStudents?: ProspectTree,
    parentsOfProspects?: ProspectTree, 
    currentStudent?: boolean, 
    alumni?: boolean, 
    faculty?: boolean, 
    guidanceCounselor?: boolean, 
    veteran?: boolean) {
      this.prospectiveStudents = prospectiveStudents || new ProspectTree();
      this.parentsOfProspects = parentsOfProspects || new ProspectTree();
      this.currentStudent = currentStudent || false;
      this.alumni = alumni || false;
      this.faculty = faculty || false;
      this.guidanceCounselor = guidanceCounselor || false;
      this.veteran = veteran || false; 
  }
}